module.exports = __webpack_public_path__ + "static/media/04.e24441fd.jpg";